import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";

import * as actions from "../../../../../redux/projects/actions";
import {
  isCreatingProject,
  getActiveProject,
} from "../../../../../redux/projects";
import { loadTimelineEvents } from "../../../../../redux/timeline/actions";
import {
  isCreatingEvent,
  getTimelineEvents,
} from "../../../../../redux/timeline";

import type TimelineEventCollection from "../../models/TimelineEventCollection";
import type Project from "../../models/Project";
import type User from "../../models/User";

import ProjectForm from "../../../../../components/forms/project-form/ProjectForm";
import ProjectFormUpdate from "../../../../../components/forms/project-form-update/ProjectFormUpdate";

type Props = {
  user: ?User,
  onModalClose: () => void,
  project: Project,
};

type StateProps = {
  isCreatingEvent: boolean,
  isCreatingProject: boolean,
  activeProject: ?Project,
  timelineEvents: ?TimelineEventCollection,
};

type State = {
  projectId: ?string,
  projectName: ?string,
  projectDate: ?string,
  timezone: ?string,
};

class ProjectModal extends Component {
  props: Props;
  state: State = {
    projectId: null,
    projectName: null,
    projectDate: null,
    timezone: null,
  };
  createProjectPromise: ?Promise<void>;
  updateProjectPromise: ?Promise<void>;
  deleteProjectPromise: ?Promise<void>;
  loadTimelineEventsPromise: ?Promise<void>;

  constructor(props: Props) {
    super(props);
  }

  componentDidUpdate() {
    if (this.props.activeProject && !this.loadTimelineEventsPromise) {
      this.loadTimelineEventsPromise = Promise.resolve(
        this.props.loadTimelineEvents()
      );
    }
  }

  render() {
    return (
      <div>
        <Modal.Dialog>
          {this.props.activeProject || this.props.project
            ? this.renderUpdateProjectForm()
            : this.renderProjectForm()}
        </Modal.Dialog>
      </div>
    );
  }

  renderProjectForm() {
    return (
      <div>
        <Modal.Header>
          <Modal.Title>New Event</Modal.Title>
        </Modal.Header>
        <ProjectForm
          createProject={this.props.createProject}
          onDidCreateProject={this.props.onModalClose}
          user={this.props.user}
          onModalClose={this.props.onModalClose}
        />
      </div>
    );
  }

  renderUpdateProjectForm() {
    return this.props.duplicate ? (
      this.renderDuplicateProjectForm()
    ) : (
      <div>
        <Modal.Header>
          <Modal.Title>Update Event</Modal.Title>
        </Modal.Header>
        <ProjectFormUpdate
          updateProject={this.props.updateProject}
          onDidUpdateProject={this.props.onModalClose}
          user={this.props.user}
          onModalClose={this.props.onModalClose}
          project={this.props.project}
        ></ProjectFormUpdate>
      </div>
    );
  }

  renderDuplicateProjectForm() {
    return (
      <div>
        <Modal.Header>
          <Modal.Title>Duplicate Event</Modal.Title>
        </Modal.Header>
        <ProjectForm
          handleDuplicateProject={({ date }) =>
            this.props.handleDuplicateProject({
              date,
              timelineEvents: this.props.timelineEvents,
            })
          }
          onDidDuplicateProject={this.props.onModalClose}
          user={this.props.user}
          onModalClose={this.props.onModalClose}
          duplicate={true}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isCreatingEvent: isCreatingEvent(state),
    isCreatingProject: isCreatingProject(state),
    activeProject: getActiveProject(state),
    timelineEvents: getTimelineEvents(state),
  };
};

const mapActionsToProps = { ...actions, loadTimelineEvents };

export default connect(mapStateToProps, mapActionsToProps)(ProjectModal);



// WEBPACK FOOTER //
// ./src/views/user/components/modals/project-modal/ProjectModal.js